window.WorkRestrictionAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['WorkRestriction']);

    self.getWorkRestrictionRules = function(brandId){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_restriction_rules', 'GET', {})
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandWorkRestrictionRules = function (brandId, week) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            week: week
        };

        _protected.request('brands/' + brandId + '/work_restriction_rules', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getUsersSchoolTemplates = function (brandId, params) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/school_templates', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data.users || []);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandWorkVisaTypes = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/work_visa_types', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data.work_visa_types || []);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.updateWorkRestrictionRule = function(brandId, ruleId, payload){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_restriction_rules/'+ ruleId, 'PUT', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.addWorkRestrictionRule = function(brandId, payload){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_restriction_rules', 'POST', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.deleteWorkRestrictionRule = function(brandId, ruleId){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_restriction_rules/'+ ruleId, 'DELETE')
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUsersSchoolsCalenders = function (brandId, week) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            week: week
        };

        _protected.request('brands/' + brandId + '/users/school_templates/periods', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandWorkVisaTypes = function(brandId){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/work_visa_types', 'GET', {})
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getWorkVisaTypesSettings = function(brandId, status){
        var deferred = $q.defer();
        var params = {};

        if (status) {
            params['status'] = status;
        }

        _protected.request('brands/' + brandId + '/settings/work_visa_types', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.updateWorkVisaTypeSettings = function(brandId, typeId, payload){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_visa_types/'+ typeId, 'PUT', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.addWorkVisaType = function(brandId, payload){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_visa_types', 'POST', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.recoverWorkVisaTypeSettings = function(brandId, typeId, payload){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_visa_types/'+ typeId + '/recover', 'POST', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.deleteWorkVisaType = function(brandId, typeId){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/work_visa_types/'+ typeId, 'DELETE')
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSchoolTemplateCalendars = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/school_templates', 'GET', {})
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateSchoolTemplateCalendar = function (brandId, templateId, data) {
        var deferred = $q.defer();
        var payload = {brand_school_template: data};

        _protected.request('brands/' + brandId + '/settings/school_templates/' + templateId, 'PUT', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addSchoolTemplateCalendar = function (brandId, data) {
        var deferred = $q.defer();
        var payload = {brand_school_template: data};

        _protected.request('brands/' + brandId + '/settings/school_templates', 'POST', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteSchoolTemplateCalendar = function (brandId, templateId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/school_templates/' + templateId, 'DELETE')
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

});
